import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HotToastService } from '@ngneat/hot-toast';
import { Subscription } from 'rxjs';
import { UserAccountRegDto } from 'src/app/core/dtos/dto';
import { RegistrationService } from 'src/app/core/services/registration.service';

@Component({
  selector: 'app-web-delivery-actions',
  templateUrl: './web-delivery-actions.component.html',
  styleUrls: ['./web-delivery-actions.component.scss']
})
export class WebDeliveryActionsComponent implements OnInit, OnDestroy {

  reg: UserAccountRegDto;
  regId: number;
  registrationDetailsSubscription: Subscription;

  constructor(
    private registrationService: RegistrationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: HotToastService
  ) { }

  ngOnInit(): void {
    this.regId = Number(this.activatedRoute.snapshot.params.regId);
    this.registrationDetailsSubscription = this.registrationService.getTestInfo(this.regId)
      .subscribe(
        (result) => {
          this.reg = result.content;
        },
        () => {
          this.toastService.warning("Failed to load test registration info.");
          this.router.navigate(['my-account']);
        }
      );
  }

  ngOnDestroy() {
    this.registrationDetailsSubscription?.unsubscribe();
  }

}
